import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Gamepad2 } from 'lucide-react';

const Splash = () => {
  const navigate = useNavigate();
  const { authenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => {
        if (authenticated) {
          navigate('/app/dashboard');
        } else {
          navigate('/login');
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [loading, authenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B132B] p-4">
      {/* Logo Manette Doré */}
      <div className="w-32 h-32 mb-6 bg-gradient-to-br from-[#C6A15B] to-[#B89149] rounded-3xl flex items-center justify-center shadow-2xl animate-pulse">
        <Gamepad2 className="w-20 h-20 text-[#0B132B]" strokeWidth={2.5} />
      </div>
      
      {/* Titre avec Immersion ajusté */}
      <h1 className="text-4xl md:text-5xl font-bold text-[#EAEAEA] mb-1 tracking-wide">PlayCity</h1>
      <h2 className="text-3xl md:text-4xl font-semibold text-[#EAEAEA] mb-2 tracking-[0.3em]">Immersion</h2>
      <p className="text-sm md:text-base text-[#EAEAEA]/70 mb-1 tracking-wide">Jouez, Apprenez, Vivez l'immersion !</p>
      
      {/* Subtitle */}
      <p className="text-[#C6A15B] text-lg md:text-xl mb-8 tracking-wide">
        Caisse & Gestion
      </p>
      
      {/* Loading Dots */}
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-[#C6A15B] rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
        <div className="w-3 h-3 bg-[#C6A15B] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        <div className="w-3 h-3 bg-[#C6A15B] rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
      </div>
    </div>
  );
};

export default Splash;
